import * as React from "react"
import { FormattedMessage, useIntl } from "react-intl"
import { Banner } from "@/components/blocks/Banner"
import { useFeedback } from "@/components/feedback/FeedbackProvider"

// Bump the number when the wording changes, so everyone sees the new notice once.
const STORAGE_KEY = "beta-banner-dismissed-v1"

/** The beta notice at the top of the app. Dismissed per browser; it's a convenience, so storage failures are ignored. */
export function BetaBanner() {
  const intl = useIntl()
  const { setOpen } = useFeedback()
  // Hidden until we've checked storage, so server and client render the same markup.
  const [visible, setVisible] = React.useState(false)

  React.useEffect(() => {
    try {
      setVisible(window.localStorage.getItem(STORAGE_KEY) !== "true")
    } catch {
      setVisible(true)
    }
  }, [])

  if (!visible) return null

  const dismiss = () => {
    setVisible(false)
    try {
      window.localStorage.setItem(STORAGE_KEY, "true")
    } catch {
      // Private window or blocked storage: it just shows again next time.
    }
  }

  return (
    // The mobile menu button floats over the top-right corner, so leave it room.
    <div className="mt-4 lg:mt-0">
      <Banner onDismiss={dismiss} dismissLabel={intl.formatMessage({ id: "beta.dismiss" })}>
        <FormattedMessage
          id="beta.banner"
          values={{
            strong: (chunks) => <strong>{chunks}</strong>,
            link: (chunks) => (
              <button type="button" className="cursor-pointer font-medium underline" onClick={() => setOpen(true)}>
                {chunks}
              </button>
            ),
          }}
        />
      </Banner>
    </div>
  )
}
